export enum ViguideBreakpoints {
  xs = 576,
  sm = 768,
  md = 1084,
  lg = 1280,
}

export const RSA_DASHBOARD_WIDTH = 1234;
export const MAINTAINER_DASHBOARD_WIDTH = 1540;
